import i18n from '@/libs/i18n'
import appInstance from '../app-instance'

// Confirmation dialog with one shared layout; the safe choice is first and receives focus.
export default function useModalDialog() {
  const modal = ({
    message, title, options, type, okTitle,
  }) => {
    const newType = type || 'danger'
    const newOptions = {
      title: title || '',
      modalClass: `mom-dialog mom-dialog--${newType}`,
      size: 'sm',
      buttonSize: 'md',
      okVariant: newType,
      okTitle: okTitle || i18n.t('general.yes'),
      cancelTitle: i18n.t('foundation.cancel'),
      cancelVariant: 'outline-secondary',
      headerCloseLabel: i18n.t('foundation.close'),
      hideHeaderClose: false,
      autoFocusButton: newType === 'danger' ? 'cancel' : 'ok',
      footerClass: 'mom-dialog-footer',
      centered: true,
      ...options,
    }
    return appInstance.current.$bvModal.msgBoxConfirm(message, newOptions)
  }
  return modal
}
